import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { ResponsiveRender } from '@machobear/design-system'
import { colors, fontSizes, fontWeights } from '@/styles'

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${colors.white};
  z-index: 100;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.3);

  ${props =>
    props.displayBlock &&
    `
    display: block;
    position: static;
  `}
`

const Button = styled(Link)`
  background: ${colors.secondary};
  color: ${colors.white};
  font-size: ${fontSizes.regular};
  font-weight: ${fontWeights.medium};
  letter-spacing: -0.39px;
  line-height: 20px;
  border: none;
  border-radius: 0;
  margin: 0;
  padding: 10px 20px;
  height: 56px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
  cursor: pointer;

  &:hover:not(:disabled) {
    opacity: 0.7;
  }

  &:disabled {
    cursor: not-allowed;
  }
`

const MobileFooterButton = ({
  to,
  onClick,
  displayBlock,
  children,
  disabled,
  displayBelow,
  ...rest
}) => {
  return (
    <ResponsiveRender below={displayBelow}>
      <Wrapper displayBlock={displayBlock}>
        <Button {...rest} as={to ? Link : 'button'} to={to} onClick={onClick} disabled={disabled}>
          {children}
        </Button>
      </Wrapper>
    </ResponsiveRender>
  )
}

export default MobileFooterButton
